module.exports = __webpack_public_path__ + "static/media/3.37c424fb.png";